export default __webpack_public_path__ + "static/media/eventos-admin-icon.df073762.svg";